import React, { useState, useRef } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import PageSection from 'src/layouts/page-section';
import BackNavigation from 'src/components/ui/headers/title-back';
import { useTranslation } from 'react-i18next';
import { tokens } from 'src/locales/tokens';
import AddIcon from 'src/icons/untitled-ui/free/push';
import { AssignStudentsView } from './assign-students-view';
import useForms from 'src/api/courses/vm-form';
import useToast from 'src/utils/toast-utils';
import useDeviceView from 'src/hooks/use-device-view';

const Page = ({ onNavigate, item }) => {
  const { t } = useTranslation();
  const { useCompactLayout } = useDeviceView();
  const rootRef = useRef(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [totalSelected, setTotalSelected] = useState('00');

  const { assignStudent } = useForms();
  const { toastSuccess, toastError } = useToast();

  const onAddSelected = (item, list) => {
    setSelectedIds(list);

    const selectedCountLabel = list.length.toString().padStart(2, '0');
    setTotalSelected(selectedCountLabel);
  };

  const handleAddClicked = async () => {
    // Call api for add and redirect to page
    if(0 === selectedIds.length){
      toastError('Chưa chọn học viên');
      return;
    }

    const arrays = [];
    selectedIds.forEach(element => {
      arrays.push({id: element.optionId, code: element.primaryCode});
    });

    const params = {courseId: item.id, values: arrays};
    await assignStudent(params,
      (result) => {
        const msg = `${arrays.length} Học viên đã được thêm vào khóa ${item.name}`;
        toastSuccess(msg, {action: 'back'});
      },
      (error) => {
        toastError(error);
      },
    );
  };
  
  return (
    <PageSection title="Course Assign" rootRef={rootRef}>
      <Stack spacing={1}>
        <BackNavigation
          onBackClick={onNavigate}
          label={t(tokens.nav.course)}
          subLabel={item.name}
          extraContent={
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              onClick={handleAddClicked}
              disabled={totalSelected === '00'}
            >
              Thêm
              <Box
                sx={{
                  ml: 1,
                  minWidth: 20,
                  display: 'inline-flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  fontFamily: 'monospace',
                }}
              >
                <Typography
                  variant="caption" 
                  sx={{ fontSize: '1rem', fontWeight: 'bold', lineHeight: 1 }}
                >
                  {totalSelected}
                </Typography>
              </Box>
            </Button>
          }
        />
        <AssignStudentsView items={item?.students || []} onAddSelected={onAddSelected} usePhoneView={useCompactLayout} />
      </Stack>
    </PageSection>
  );
};

export default Page;
